import { create } from 'zustand';
import { hardDeleteSingleShift } from '@libs/api/shifts';

type InitialState = {
  open: boolean;
  loading: boolean;
  id: string | null;
  externalId: string | null;
  openModal: (shiftId: string, externalId?: string | null) => void;
  closeModal: () => void;
  hardDelete: (shiftId: string) => Promise<void>;
};

export const useHardDeleteModalStore = create<InitialState>()((set) => ({
  open: false,
  loading: false,
  id: null,
  externalId: null,
  hardDelete: async (shiftId) => {
    set({
      loading: true,
    });
    try {
      await hardDeleteSingleShift(shiftId);
      set({
        loading: false,
      });
    } finally {
      set({
        loading: false,
      });
    }
  },
  openModal: (shiftId, externalId) => set({ open: true, id: shiftId, externalId: externalId ? externalId : null }),
  closeModal: () => set({ open: false, id: null }),
}));
